import { Form, Input, Button, Card, message } from "antd";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../store";

export default function Login() {
  const nav = useNavigate();
  const setSession = useAuth((s) => s.setSession);

  const onFinish = async (vals: { username: string; password: string }) => {
    try {
      const { data } = await api.post("/login", vals);
      setSession(data.access_token, data.role);
      message.success("登录成功");
      nav("/");
    } catch (e: any) {
      message.error(e?.response?.data?.error ?? "登录失败");
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#07080B" }}>
      <Card
        style={{ width: 360, background: "#10131A", border: "1px solid #1A1D26" }}
        styles={{ body: { padding: 28 } }}
      >
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#F5F5F7" }}>
            QX-CHAT Admin
          </div>
          <div style={{ fontSize: 12, color: "#6B7280", marginTop: 4 }}>
            v0.1 · super_admin / ops_admin / finance / auditor
          </div>
        </div>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item label="账号" name="username" rules={[{ required: true }]}>
            <Input autoFocus />
          </Form.Item>
          <Form.Item label="密码" name="password" rules={[{ required: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large">
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
